import axiosRegular from "../axios";

export async function makePostApiCall(endPoint, payload, contentType) {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("authToken"),
      "content-type": contentType ? contentType : "application/json",
    },
  };

  return axiosRegular
    .post(endPoint, payload, config)
    .then((response) => {
      return {
        success: true,
        data: response.data,
      };
    })
    .catch((err) => {
      console.log("err", err.response);
      const emptyData = {
        data: {
          title: "Oops",
          subtitle: "We could not complete the action.",
          errorStatus: err.response.status,
        },
      };

      if (err.response) {
        if (err.response.data) {
          return {
            success: false,
            data: err.response.data,
            errorStatus: err.response.status,
          };
        }
        return emptyData;
      } else {
        return {
          success: false,
          data: emptyData,
          errorStatus: err.response.status,
        };
      }
    });
}

export async function makeGetApiCall(endPoint) {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };

  return axiosRegular
    .get(endPoint, config)
    .then((response) => {
      return {
        success: true,
        data: response.data,
      };
    })
    .catch((err) => {
      console.log("err", err.response);
      const emptyData = {
        data: {
          title: "Oops",
          subtitle: "We could not complete the action.",
          errorStatus: err.response.status,
        },
      };

      if (err.response) {
        if (err.response.data) {
          return {
            success: false,
            data: err.response.data,
            errorStatus: err.response.status,
          };
        }
        return emptyData;
      } else {
        return {
          success: false,
          data: emptyData,
          errorStatus: err.response.status,
        };
      }
    });
}

export async function makePostApiCallForFile(endPoint, payload, contentType) {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("authToken"),
      "content-type": contentType ? contentType : "application/json",
    },
    responseType: "blob", // Required for binary file downloads (Excel, PDF, etc.)
  };

  return axiosRegular
    .post(endPoint, payload, config)
    .then((response) => {
      return {
        success: true,
        data: response.data, // This will be a Blob
      };
    })
    .catch((err) => {
      console.log("err", err.response);
      const emptyData = {
        data: {
          title: "Oops",
          subtitle: "We could not complete the action.",
          errorStatus: err.response?.status,
        },
      };

      if (err.response) {
        // Try to parse error response if it's JSON (some APIs return JSON errors even with blob responseType)
        if (err.response.data && typeof err.response.data === "object") {
          return {
            success: false,
            data: err.response.data,
            errorStatus: err.response.status,
          };
        }
        return {
          success: false,
          data: emptyData,
          errorStatus: err.response.status,
        };
      } else {
        return {
          success: false,
          data: emptyData,
          errorStatus: err.response?.status,
        };
      }
    });
}
